import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=34fc28e3&scoped=true&"
import script from "./FAQComponent.vue?vue&type=script&lang=js&"
export * from "./FAQComponent.vue?vue&type=script&lang=js&"
import style0 from "./FAQComponent.vue?vue&type=style&index=0&id=34fc28e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc28e3",
  null
  
)

export default component.exports